export enum EStockReconciliationUoM {
  Packs = 'packs',
  Pcs = 'pcs',
}

export enum EStockReconciliationVarianceType {
  All = 'all',
  Positive = 'positive',
  Negative = 'negative',
}

export interface IStockReconciliationShiftListItem {
  shiftKey: string;
  weekLabel: string;
  day: string;
  shiftId: string | null;
  startAt: string | null;
  endAt: string | null;
  crew: string | null;
  witness: string | null;
  varTotal: number | null;
  positivePercent: number | null;
  negativePercent: number | null;
}

export interface IStockReconciliationShiftItem {
  category: string | null;
  item: string;
  code: string;
  bi: number | null;
  del: number;
  sold: number;
  transIn: number;
  transOut: number;
  ei: number | null;
  actual: number | null;
  variance: number | null;
}

export interface IStockReconciliationBaseMeta {
  count: number;
  [key: string]: unknown;
}

export interface IStockReconciliationShiftCollection {
  data: IStockReconciliationShiftListItem[];
  meta: IStockReconciliationBaseMeta;
}

export interface IStockReconciliationShiftItemsCollection {
  data: IStockReconciliationShiftItem[];
  meta: IStockReconciliationBaseMeta;
}

export interface IStockReconciliationShiftFilters {
  storeCode: string;
  location: string;
  week?: string;
  uom?: EStockReconciliationUoM;
  offset?: number;
  limit?: number;
}

export interface IStockReconciliationShiftItemsFilters {
  shiftKey: string;
  uom?: EStockReconciliationUoM;
  varianceType?: EStockReconciliationVarianceType;
  search?: string;
}
